import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

const fetchRedirectNeeded = (successCallback, errorCallback) => {
    return UpdoxApi.getApi(
        '/api/public/redirect-needed',
        headers,
        successCallback,
        errorCallback,
    );
};

const getPracticeDetails = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/public/practice-details',
    headers,
    successCallback,
    errorCallback,
  );
};

const PublicApi = {
  fetchRedirectNeeded,
  getPracticeDetails,
};

export default PublicApi;



// WEBPACK FOOTER //
// ./src/apis/public.js